"use client"
import React, { useState, useRef, useEffect } from "react";

import PropTypes from "prop-types";
import useScrollBox from "@/components/shared/useScrollBox";
import "@/components/shared/ScrollBox.css";

function ScrollBox({
  children,
  className,
  containerClassName,
  wrapperClassName
}) {
  const scrollWrapperRef = useRef();
  const { scrollRef, isDragging, onExternalScroll } = useScrollBox(
    scrollWrapperRef
  );

  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const [id, setId] = useState("unset");

  const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
  };

  var observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.target.id.endsWith("first")) {
        setShowLeft(entry.intersectionRatio < 0.25);
      }
      if (entry.target.id.endsWith("last")) {
        setShowRight(entry.intersectionRatio < 0.25);
      }
    });
  };

  useEffect(() => {
    setId(getRandomInt(10000, 99999));

    var options = {
      root: document.querySelector(`#scroll-box-${id}`),
      threshold: [0.25, 0.5, 0.75]
    };

    var observer = new IntersectionObserver(observerCallback, options);

    var first = document.querySelector(`#scroll-item-${id}-first`);
    if (first) {
      observer.observe(first);
    }
    var last = document.querySelector(`#scroll-item-${id}-last`);
    if (last) {
      observer.observe(last);
    }
  }, []);

  return (
    <div className={`scroll-box-and-buttons ${wrapperClassName ?? ""}`}>
      <div className={`scroll-box__left-arrow ${showLeft ? "show" : "hide"}`}>
        <button
          className="btn btn-secondary circle"
          onClick={evt => {
            evt.preventDefault();
            evt.stopPropagation();
            onExternalScroll(-1);
          }}
        >
          <span className="material-icons">chevron_left</span>
        </button>
      </div>
      <div
        id={`scroll-box-${id}`}
        className={`scroll-box ${className ? className : ""}`}
      >
        <div className="scroll-box__wrapper" ref={scrollWrapperRef}>
          <div
            className={`scroll-box__container ${containerClassName ?? ""}`}
            role="list"
            style={{ pointerEvents: isDragging ? "none" : undefined }}
          >
            {children.map((child, i) => {
              var token =
                i === 0 ? "first" : i === children.length - 1 ? "last" : i;
              var listItemId = `scroll-item-${id}-${token}`;
              return (
                <div
                  role="listitem"
                  id={listItemId}
                  key={`scroll-box-item-${i}`}
                  className="scroll-box__item"
                >
                  {child}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className={`scroll-box__right-arrow ${showRight ? "show" : "hide"}`}>
        <button
          className="btn btn-secondary circle"
          onClick={evt => {
            evt.preventDefault();
            evt.stopPropagation();
            onExternalScroll(1);
          }}
        >
          <span className="material-icons">chevron_right</span>
        </button>
      </div>
    </div>
  );
}

ScrollBox.propTypes = {
  children: PropTypes.node.isRequired
};

export default ScrollBox;
